import { FormattedMessage } from 'react-intl'
import {Contest_SiteEventListToolbar} from './Contest_SiteEventListToolbar'

const Contest_SiteEventListHeader = () => {

  return (
    <div className='card-header border-0 pt-6'>
      <h2 className='fw-bolder'>{<FormattedMessage id ="CONTESTS_SITE.EVENTS.LIST"/>}</h2>
      {/* <ParametersListSearchComponent /> */}
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {<Contest_SiteEventListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {Contest_SiteEventListHeader}
